const Pricing = () => {
  const plans = [
    {
      name: "Start",
      price: "395",
      sub: "— upp till 6 anställda.",
      desc: "För dig som börjar strukturera firman.",
      features: [
        "Inkorg för nya affärer",
        "Påminnelser till godkända affärer",
        "Offerter med mallar & manuella rader",
        "Hantverksavtal med mallar",
        "Automatisk ROT-avdrag & moms",
        "E-signatur direkt från Byggro",
      ],
      cta: "Starta gratis",
      featured: false,
    },
    {
      name: "Bygg",
      price: "795",
      sub: "— upp till 12 anställda.",
      desc: "För team som vill se sina marginaler — på riktigt.",
      features: [
        "Allt i Start",
        "Projektvy med budget vs utfall",
        "Aktivitetslogg per projekt",
        "Lönsamhetsrapporter",
        "Påslag & rabatter per kund",
        "AI-tolkning av inkommande förfrågningar",
        "Röstmemo & SMS-intake",
        "Anslut källor (Offerta, Google, Servicefinder m.fl.)",
        "Dokumentuppladdning för garantier m.m.",
      ],
      cta: "Välj Bygg",
      featured: true,
    },
    {
      name: "Firma",
      price: "1 695",
      sub: "— obegränsade användare.",
      desc: "För etablerade firmor som vill skala kontrollerat.",
      features: [
        "Allt i Bygg",
        "Offerter med AI-utkast från liknande projekt",
        "AI-driven mönsteranalys",
        "OCR & dokumentscanning",
        "Rollstyrning & behörigheter",
        "API-åtkomst",
        "Dedikerad kontaktperson",
      ],
      cta: "Kontakta säljare",
      featured: false,
    },
  ];

  return (
    <section className="section" id="priser">
      <div className="container">
        <div className="section-head">
          <h2>Tre paket. Inga uppstartsavgifter.</h2>
          <p className="lede" style={{ marginTop: 18 }}>
            Betala månadsvis, ingen bindingstid.
            <br />
            Byt eller säg upp när du vill.
          </p>
        </div>
        <div className="pricing-grid">
          {plans.map((p) => (
            <div key={p.name} className={`pricing-card card ${p.featured ? "featured" : ""}`}>
              {p.featured && <div className="featured-tag">Mest valda</div>}
              <div className="plan-name">{p.name}</div>
              <div className="plan-desc">{p.desc}</div>
              <div className="plan-price">
                <span className="plan-amount">{p.price}</span>
                <span className="plan-curr">kr / mån</span>
              </div>
              <div className="plan-sub">{p.sub}</div>
              <a
                href="#demo"
                className={`btn ${p.featured ? "btn-primary" : "btn-secondary"}`}
                style={{ marginTop: 24, width: "100%", justifyContent: "center" }}
              >
                {p.cta}
              </a>
              <hr className="divider" style={{ margin: "28px 0 20px" }} />
              <ul className="plan-features">
                {p.features.map((f) => (
                  <li key={f}>{f}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: 40, fontSize: 13.5, color: "var(--ink-3)" }}>
          Är ni fler än 25 anställda?{" "}
          <a href="#demo" style={{ color: "var(--primary)", borderBottom: "1px solid currentColor" }}>
            Prata med oss om Firma+
          </a>
        </div>
      </div>
    </section>
  );
};

Object.assign(window, { Pricing });
